module.exports = __webpack_public_path__ + "static/media/no-store-selected.ae9c20ea.png";